const map = {
	"./aerobics-girl.png": 1298,
	"./alien.png": 1299,
	"./arcade-cabinet.png": 1300,
	"./aviator-glasses.png": 1301,
	"./boombox.png": 1302,
	"./cassette.png": 1303,
	"./delorean.png": 1304,
	"./electroguitar.png": 1305,
	"./elvis.png": 1306,
	"./floppy.png": 1307,
	"./ghost.png": 1308,
	"./hustler.png": 1309,
	"./joystick.png": 1310,
	"./officer.png": 1311,
	"./pc.png": 1312,
	"./pizza.png": 1313,
	"./player.png": 1314,
	"./rollers.png": 1315,
	"./skateboard.png": 1316,
	"./sneakers.png": 1317,
	"./synthesizer.png": 1318,
	"./telephone.png": 1319,
	"./tv.png": 1320,
	"./yuppie.png": 1321,
	"./zombie.png": 1322
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1297;